import React, { Component } from 'react'
import {
  Advertisement,
   //Button,
   //Checkbox,
   Form,
   Header,
   Segment,
   Message
 } from 'semantic-ui-react'

export default class ModalFirstVisit extends Component {
  constructor(props){
    super(props)
    this.state = {
      modalOpen: true,
      tabs: 5,
      dosage: 100,
      solution: 100,
      targetDosage: 10,
      frequency: 3
    }
    this.roundNumber = this.roundNumber.bind(this);
  }

   roundNumber = (num, scale) => {
    if(!("" + num).includes("e")) {
      return +(Math.round(num + "e+" + scale)  + "e-" + scale);
    } else {
      var arr = ("" + num).split("e");
      var sig = ""
      if(+arr[1] + scale > 0) {
        sig = "+";
      }
      return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
    }
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value })
    localStorage.setItem([name], value);
  }

  hydrateStateWithLocalStorage() {
    // for all items in state
    for (let key in this.state) {
      // if the key exists in localStorage
      if (localStorage.hasOwnProperty(key)) {
        // get the key's value from localStorage
        let value = localStorage.getItem(key);

        // parse the localStorage string and setState
        try {
          value = JSON.parse(value);
          this.setState({ [key]: value });
        } catch (e) {
          // handle empty string
          //this.setState({ [key]: value });
        }
      }
    }
  }

  componentDidMount() {
    (window.adsbygoogle = window.adsbygoogle || []).push({})
    this.hydrateStateWithLocalStorage();
  }

  render() {
    const { tabs, dosage, solution, targetDosage, frequency } = this.state
    return (
            <Segment.Group>
              <Segment>
                <Header
                  as='h2'
                  icon='flask'
                  content='Volumetric Dosing Calculator' />
              </Segment>
              <Segment
                raised
                padded='very'
                color='teal'
                textAlign='center'>
                <Form>
                  <Form.Group widths='equal'>
                    <Form.Input
                      fluid
                      label='Tab Dosage (mcg)'
                      placeholder='100'
                      name='dosage'
                      value={dosage}
                      onChange={this.handleChange} />
                    <Form.Input
                      fluid
                      label='# of Tabs'
                      placeholder='5'
                      name='tabs'
                      value={tabs}
                      onChange={this.handleChange}  />
                    <Form.Input
                      fluid
                      label='Vodka or Water (mL)'
                      placeholder='100'
                      name='solution'
                      value={solution}
                      onChange={this.handleChange}  />
                  </Form.Group>
                  <Message
                    positive={((tabs * dosage)/solution) < 25 && ((tabs * dosage)/solution) > .5 ? true : false}
                    negative={((tabs * dosage)/solution) >= 25 || ((tabs * dosage)/solution) <= .5 ? true : false}>
                    <Message.Header>Concentration is {this.roundNumber((tabs * dosage)/solution, 2)} mcg/mL </Message.Header>
                    <Message.List>
                      {((tabs * dosage)/solution) >= 25 ? <Message.Item><b>High concentrations may make dosing imprecise. Add Vodka/Water.</b></Message.Item> : null}
                      {((tabs * dosage)/solution) <= .5 ? <Message.Item><b>Low concentration may make dosing tedious...</b></Message.Item> : null}
                      <Message.Item>For 5mcg microdose, take {this.roundNumber(5 / ((tabs * dosage)/solution), 2)}mL</Message.Item>
                      <Message.Item>For 10mcg microdose, take {this.roundNumber(10 / ((tabs * dosage)/solution), 2)}mL</Message.Item>
                    </Message.List>
                  </Message>
                </Form>
              </Segment>
              <Segment
                raised
                padded='very'
                color='yellow'
                textAlign='center'>
                  <Form>
                  <Form.Group widths='equal'>
                    <Form.Input
                      fluid
                      label='Desired Dosage (mcg)'
                      placeholder='10'
                      name='targetDosage'
                      value={targetDosage}
                      onChange={this.handleChange} />
                    <Form.Input
                      fluid
                      label='Frequency of Dosing (Days)'
                      placeholder='3'
                      name='frequency'
                      value={frequency}
                      onChange={this.handleChange}  />
                  </Form.Group>
                  <Message
                    positive={targetDosage < 26 && targetDosage > 5 ? true : false}
                    negative={targetDosage >= 26 || targetDosage <= 5 ? true : false}>
                    <Message.Header>Volumetric dose for target of {targetDosage}mcg is { this.roundNumber(targetDosage / ((tabs * dosage)/solution), 2) }mL</Message.Header>
                    <Message.List>
                      {targetDosage >= 26 ? <Message.Item><b>This dosage is high for a microdose! Are you sure?</b></Message.Item> : null}
                      {targetDosage <= 5 ? <Message.Item><b>This dosage is low, even for a microdose! Are you sure?</b></Message.Item> : null}
                      <Message.Item>For 5mcg microdose, take {this.roundNumber(5 / ((tabs * dosage)/solution), 1)}mL</Message.Item>
                      <Message.Item>Supply will last {this.roundNumber((tabs * dosage)/targetDosage * frequency, 1)} days at target dosage.</Message.Item>
                    </Message.List>
                  </Message>
                </Form>
              </Segment>
              {/*
              // TODO: Get advertisement working
              <Segment
                raised
                color='orange'
                textAlign='center'>
                <Advertisement unit='medium rectangle'>
                  <ins
                    className='adsbygoogle'
                    data-ad-client='ca-pub-6152173886594342'
                    data-ad-format='auto'
                    data-ad-slot='3581449766'
                    style={{ display: 'block' }}
                  />
                </Advertisement>
              </Segment>
              */}
          </Segment.Group>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/calculator.js